module.exports = __webpack_public_path__ + "static/media/subscription.60c6a25b.svg";